// imports section
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import AddToolbar from "../../components/common/AddToolbar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";

import {
  COMPCODE,
  LOCCODE,
  BUSINESSTYPECODE,
  EMPLOYEE_API_01,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import { useSelector } from "react-redux";
import Slide from "@mui/material/Slide";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";

const UserGroups = () => {
  // Hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [errors, setErrors] = useState({});
  const { COMPCODE, LOCCODE, BUSINESSTYPECODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const gotToPage = () => {
    navigate("/vusergroup");
  };

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const isEdit = location.state?.actionText === "Edit";
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    GROUPCODE: "",
    GROUPNAME: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        GROUPCODE: String(selectedItem.GROUPCODE),
        GROUPNAME: selectedItem.GROUPNAME,
      });
    }
  }, [selectedItem]);

  useEffect(() => {
    fetchData();
  }, []);

  // Handlers

  const fetchData = async () => {
    try {
      const result = await externalgetApi(EMPLOYEE_API_01, "get", {
        COMPCODE,
        LOCCODE,
        BUSINESSTYPECODE,
        STS: CON_STATUS_ACTIVE,
      });
      setData(result);
    } catch (err) {
      setError(err);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }

    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };

  const handleConfirmClick = async () => {
    const { GROUPNAME } = selectedItemDetails;

    const requiredFields = [
      { name: "GROUPNAME", value: GROUPNAME, label: "Group name" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (
          item.GROUPCODE != selectedItemDetails.GROUPCODE &&
          item.GROUPNAME === GROUPNAME
        ) {
          return true;
        } else {
          return false;
        }
      });

      if (isDuplicate) {
        setSnackbarMessage(" Name already exists."); // Show snackbar if duplicate found
        setOpenErrorSnackbar(true);
        return;
      }
    }

    const staticValues = {
      COMPCODE,
      LOCCODE,
      BUSINESSTYPECODE,
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,

      LOCDATE: new Date().toISOString(),
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(EMPLOYEE_API_01, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        GROUPCODE: "",
        GROUPNAME: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleInputValidation = (event) => {
    const { name, value } = event.target;

    // Allow only letters and spaces
    const regex = /^[a-zA-Z\s]*$/;

    if (regex.test(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      setSelectedItemDetails((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only letters and spaces are allowed.",
      }));
    }
  };

  const gotToView = () => {
    navigate("/vcategory");
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      GROUPNAME: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover" href="/">
                  Home
                </Link>
                <Link underline="hover">Employee</Link>
                <Link underline="hover">UserGroups</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "EditUser Groups" : "Create User Groups" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  User Groups Name<span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="GROUPNAME"
              value={selectedItemDetails.GROUPNAME}
              onChange={handleInputValidation}
              error={Boolean(errors.GROUPNAME)}
              helperText={errors.GROUPNAME}
            />
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}></Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit ? " Updated Successfully!" : " Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          // Slide in from the right
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default UserGroups;
